



















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { Team, LearnerTeam } from "../types";

@Component
export default class AppSidebar extends Vue {
  @Getter private learnerTeams!: LearnerTeam[];
  @Getter private currentLearnerTeamID!: Number;
  @Getter private currentLearnerTeam!: LearnerTeam;
  @Getter private learnerTeamByID!: (id: number) => LearnerTeam;

  @Action private setCurrentLearnerTeam?: any;
  
  private teamClick(id: number) {
    console.log("TEAM CLICK", id, typeof id);
    this.$emit("teamClicked", id);
  }

  get filteredTeams() {
    return this.learnerTeams.filter(team => {
      let isCurrent = team.id === this.currentLearnerTeamID;
      let teamName = team.name.toLowerCase();
      return !isCurrent && teamName;
    });
  }
}
